// Resolves the shared public demo key used by the API reference examples.
//
// The key is deliberately NOT committed to this repo. It is already published
// in the "Datanodes Sui API Reference" article (Firestore `articles`
// collection), so we read it from there at runtime. If the article is
// unreachable the examples fall back to a YOUR_API_KEY placeholder.
import { createContext, useContext, useEffect, useState } from "react";
import { getArticleBySlug } from "./articles";

const SOURCE_ARTICLE_SLUG = "datanodes-sui-api-reference";
const KEY_RE = /sk_live_[A-Za-z0-9_-]{20,}/;

let cached; // undefined = not resolved yet, null = unavailable

export async function resolveDemoKey() {
  if (cached !== undefined) return cached;
  try {
    const article = await getArticleBySlug(SOURCE_ARTICLE_SLUG);
    const blob = JSON.stringify(article?.content || []);
    const match = blob.match(KEY_RE);
    cached = match ? match[0] : null;
  } catch {
    cached = null;
  }
  return cached;
}

// { key: string|null, ready: boolean } — shared by every code block on /api.
export const DemoKeyContext = createContext({ key: null, ready: false });

export function useDemoKey() {
  return useContext(DemoKeyContext);
}

// Hook used by the provider at the top of the API reference layout.
export function useResolvedDemoKey() {
  const [state, setState] = useState({ key: cached ?? null, ready: cached !== undefined });
  useEffect(() => {
    let cancelled = false;
    resolveDemoKey().then((key) => {
      if (!cancelled) setState({ key, ready: true });
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return state;
}
